export interface ITableSubSectionFilter {
    value: string;
    text: string;
}

export class TableSubSectionFilter implements ITableSubSectionFilter {
    public value: string;
    public text: string;

    constructor();
    // tslint:disable-next-line: unified-signatures
    constructor(obj: ITableSubSectionFilter);
    constructor(obj?: any) {
        this.value = obj && obj.value || '';
        this.text = obj && obj.text || '';
    }
}
